export enum HttpHeaders {
  ContentType = 'Content-Type',
  ContentRange = 'Content-Range',
  Authorization = 'Authorization',
  Accept = 'Accept',
}

export enum ContentType {
  ApplicationJson = 'application/json',
  ApplicationOctetStream = 'application/octet-stream',
  ApplicationZip = 'application/zip',
}

export enum ExtensionFiles {
  Zip = '.zip'
}